import {createApp} from 'vue';
import App from './App.vue';
import {createStore} from './store/store';
import {createRouter} from './router'

import {frontendConfig} from './helpers/frontend_config';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

import 'vue3-carousel/carousel.css'
import {Carousel, Slide, Pagination, Navigation} from 'vue3-carousel'

import * as VueGoogleMaps from 'vue3-google-map';
import {createGtag} from 'vue-gtag'; // For Google Analytics

import vue3Dropzone from 'dropzone-vue3';
import {vTooltip} from 'floating-vue';
import 'floating-vue/dist/style.css';
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faEdit, faTrash, faTimes, faHome, faGlobe, faSearch,
    faBook, faInfoCircle, faEyeSlash, faEye, faCheck,
    faChessRook, faFilePdf, faBullhorn, faCaretRight,
    faCaretLeft, faMugHot, faEnvelope, faStar, faUsers,
    faCalendar, faCoins, faHandHoldingHeart, faAngleDown,
    faAngleRight, faHourglassHalf, faLink
} from '@fortawesome/free-solid-svg-icons'
import {faFacebook, faFortAwesome, faInstagram, faLinkedin, faYoutube} from '@fortawesome/free-brands-svg-icons' // needs fab prefix, ex. :icon="['fab', 'fort-awesome']"
// free-regular-svg-icons also included but not currently used
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import {auth0} from "@/helpers/auth";

library.add(faEdit);
library.add(faTrash);
library.add(faTimes);
library.add(faHome);
library.add(faGlobe);
library.add(faSearch);
library.add(faBook);
library.add(faInfoCircle);
library.add(faEyeSlash);
library.add(faEye);
library.add(faCheck);
library.add(faChessRook);
library.add(faFortAwesome);
library.add(faFilePdf);
library.add(faBullhorn);
library.add(faCaretRight);
library.add(faCaretLeft);
library.add(faMugHot);
library.add(faEnvelope);
library.add(faInstagram);
library.add(faFacebook);
library.add(faYoutube);
library.add(faLinkedin);
library.add(faStar);
library.add(faUsers);
library.add(faCalendar);
library.add(faCoins)
library.add(faHandHoldingHeart);
library.add(faAngleDown);
library.add(faAngleRight);
library.add(faHourglassHalf);
library.add(faLink);

const app = createApp(App);
const router = createRouter()
const store = createStore(router)

app.mixin({
    beforeRouteUpdate(to, from, next) {
        const {asyncData} = this.$options
        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to
            })
                .then(next)
                .catch(next)
        } else {
            next()
        }
    }
})

function getMatchedComponents(route) {
    return route.matched.flatMap(record => Object.values(record.components))
}

// Add router hook for handling asyncData.
router.beforeResolve((to, from, next) => {
    const matched = getMatchedComponents(to)
    const prevMatched = getMatchedComponents(from)
    let diffed = false
    const activated = matched.filter((c, i) => {
        return diffed || (diffed = prevMatched[i] !== c)
    })
    const asyncDataHooks = activated.map((c) => c.asyncData).filter((_) => _)
    if (!asyncDataHooks.length) {
        return next()
    }

    bar.start()
    Promise.all(asyncDataHooks.map((hook) => hook({store, route: to})))
        .then(() => {
            bar.finish()
            next()
        })
        .catch(next)
})

app.use(store);
app.use(router);
app.use(vue3Dropzone);
app.use(createGtag({
    tagId: frontendConfig.GOOGLE_ANALYTICS_MEASUREMENT_ID,
    additionalAccounts: [
        {tagId: frontendConfig.GOOGLE_ADS_CONVERSION_TRACKING_TAG}
    ],
    pageTracker: {router}
}));
app.use(auth0);

app.component('font-awesome-icon', FontAwesomeIcon)
    .component('GoogleMap', VueGoogleMaps.GoogleMap)
    .component('AdvancedMarker', VueGoogleMaps.AdvancedMarker)
    .component('InfoWindow', VueGoogleMaps.InfoWindow);

app.directive('tooltip', vTooltip);

app.mixin({
    data() {
        return {
            mapsApiKey: frontendConfig.GOOGLE_MAPS_API_KEY,
        }
    }
})

app.mount('#app')